<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" role="main" >
  <router-outlet></router-outlet>
</div>
